import { ActivePromotion, PromotionType } from '../../graphQL/commons'
import {
  IConfig,
  IProduct,
  ICartProduct,
  IPromotionUiCatalog,
} from '../../interfaces'
import { getComboPromotionUiDetails } from './getComboPromotionUiDetails'
import { getDirectPromotionUiDetails } from './getDirectPromotionUiDetails'
import { getVolumePromotionUiDetails } from './getVolumePromotionUiDetails'
import { getComplexPromotionUiDetails } from './getComplexPromotionUiDetails'
import {
  getActivePromotionsFields,
  getPromotionFields,
} from '../common/getPromotionFields'
import { getMultiPromotionTag } from './getMultiPromotionUiDetails'

export interface ISetPromotionUiDetailsCatalogArgs {
  product: IProduct | ICartProduct
  config?: IConfig
  activePromotions?: ActivePromotion[]
}
/**
 * Function declaration to set promotions ui details to be shown on catalog
 *
 * @internal
 * @param product - The product to be updated
 * @param categories - The categories
 * @returns IProduct updated with promotion ui details
 */
export const setPromotionUiDetailsCatalog = ({
  product,
  config,
  activePromotions,
}: ISetPromotionUiDetailsCatalogArgs): IPromotionUiCatalog | undefined => {
  if (product.promotions?.length && config) {
    const { promotions } = product

    if (promotions.length > 1) {
      return getMultiPromotionTag({ config, promotions })
    }

    const [promotionToBeDisplayed] = promotions

    const [activePromotion] =
      activePromotions?.filter((currentActivePromotion) => {
        const {
          fields: { customerGetsItems },
        } = getActivePromotionsFields(currentActivePromotion)
        const { customerGetsItems: customerGetsItemsToBeDisplayed } =
          getPromotionFields(promotionToBeDisplayed)

        const [customerGetsItem] = customerGetsItems
        const [customerGetsItemToBeDisplayed] = customerGetsItemsToBeDisplayed

        return customerGetsItem === customerGetsItemToBeDisplayed
      }) || []
    switch (promotionToBeDisplayed.type) {
      case PromotionType.DIRECT:
        return getDirectPromotionUiDetails({
          price: product.price || 0,
          config,
          promotion: promotionToBeDisplayed,
          activePromotion,
        })
      case PromotionType.VOLUME:
        return getVolumePromotionUiDetails({
          price: product.price || 0,
          quantity: product.quantity || 0,
          config,
          promotion: promotionToBeDisplayed,
          activePromotion,
        })
      case PromotionType.COMPLEX:
        return getComplexPromotionUiDetails({
          promotion: promotionToBeDisplayed,
          config,
          activePromotion,
          price: product.price || 0,
        })
      case PromotionType.COMBO:
        return getComboPromotionUiDetails({
          promotion: promotionToBeDisplayed,
          config,
          activePromotion,
        })
      default:
        break
    }
  }
}
